/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import * as d3 from 'd3';
// import { toPercent } from '../modules/text';

const CustomTooltip = ({
  active, payload, label, valueFormatter, tooltipTemplate, primaryColor, formatterFunction,
}) => {
  const classes = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
    },
    tooltip: {
      border: '1px solid',
      borderColor: primaryColor,
      textAlign: 'left',
      maxWidth: '250px',
      padding: '5px',
      font: '1em "ff-scala-sans-pro", Arial, sans-serif',
      background: '#fff',
      zIndex: 20,
    },
  }))();

  if (active && payload) {
    return (
      <div className={classes.tooltip}>
        {/* <Typography variant="subtitle2">{label}</Typography> */}
        {payload.map((p) => {
          // console.log(p);
          let text;
          if (!formatterFunction) {
            text = tooltipTemplate || '';
            text = text.replace('#VALUE#', valueFormatter ? valueFormatter(p.value) : p.value);
            text = text.replace('#GROUPING#', label.toLowerCase());
            // we have to do a few replacements to account for differences in names
            text = text.replace('#FAMILY#', p.name.replace('For a', 'A').replace('For ', ''));
          } else {
            text = formatterFunction(p);
          }
          // console.log(d3.hsl(p.fill).l)
          return (
            <Typography variant="body2" key={p.dataKey} gutterBottom>
              <span style={{ color: d3.hsl(p.fill).l > 0.5 ? '#3e4044' : p.fill }} dangerouslySetInnerHTML={{ __html: text }} />
            </Typography>
          );
        })}
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
